module.exports = __webpack_public_path__ + "static/media/repeat.e71ac3d5.svg";